export enum FormsRoutes {
  index = 'user.forms',
  subscribe = 'user.forms.subscribe',
  clickToText = 'user.forms.clickToText',
  createClickToText = 'user.forms.clickToText.new',
  editClickToText = 'user.forms.clickToText.edit',
  editSubscribe = 'user.forms.subscribe.edit',
}
